import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Formik } from 'formik';

export default function Update(props) {

    const { id } = useParams();
    const [user, setUser] = useState([]);
    const { redirect } = useNavigate();

    // To get this working, we need to ignore the default values property in Formik, and create a new state hook variable called updateUser and set the value from our form below.
    const handleClick = (values) => {
        console.log(values);
        axios.post('http://localhost:5000/UpdateUser', { values })
            .then((response) => {
                 if (response.status === 200) {
                    redirect('/Admin/Users');
                 }
               
            })
            .catch((error) => {

            })

    }

    useEffect(() => {
        axios.post('http://localhost:5000/GetUser', { id })
            .then((response) => {
                setUser(response.data);
            })
            .catch((error) => {
                console.log(error);
            })
    })

    useEffect(() => {
        axios.post('http://localhost:5000/GetUser', { id })
            .then((response) => {
                setUser(response.data);

            })
            .catch((error) => {
                console.log(error);
            })
    }, [user])

    return (
        <React.Fragment>
            <main>
                <h1>Update User</h1>
                <span>
                    <Link to="/Admin/Users" className="btn btn-secondary">Back</Link>
                </span>
                <section>
                    <article>
                        <Formik
                            enableReinitialize={true}
                            initialValues={{ id: user._id, firstName: user.firstName, lastName: user.lastName, email: user.email, patientNumber: user.patientNumber, phoneNumber: user.phoneNumber, username: user.username, password: user.password }}
                            onSubmit={(values, { setSubmitting }) => {
                                handleClick(values);
                            }}>
                            {({
                                values,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                            }) => (
                                <form onSubmit={handleSubmit}>
                                    <div className="formContainer">
                                        <label htmlFor="id">ID:</label>
                                        <input type="text" name="id" onChange={handleChange} onBlur={handleBlur} defaultValue={user._id} disabled />
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="firstName">First Name:</label>
                                        <input type="text" name="firstName" onChange={handleChange} onBlur={handleBlur} defaultValue={user.firstName} />
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="lastName">Last Name:</label>
                                        <input type="text" name="lastName" onChange={handleChange} onBlur={handleBlur} defaultValue={user.lastName} />
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="email">Email:</label>
                                        <input type="text" name="email" onChange={handleChange} onBlur={handleBlur} defaultValue={user.email} />
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="patientNumber">Patient Number:</label>
                                        <input type="text" name="patientNumber" onChange={handleChange} onBlur={handleBlur} defaultValue={user.patientNumber} />
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="phoneNumber">Phone Number:</label>
                                        <input type="text" name="phoneNumber" onChange={handleChange} onBlur={handleBlur} defaultValue={user.phoneNumber} />
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="username">Username:</label>
                                        <input type="text" name="username" onChange={handleChange} onBlur={handleBlur} defaultValue={user.username} />
                                    </div>
                                    <div className="formContainer">
                                        <label htmlFor="password">Password:</label>
                                        <input type="password" name="password" onChange={handleChange} onBlur={handleBlur} defaultValue={user.password} />
                                    </div>
                                    <button type="submit">Submit</button>
                                </form>
                            )}
                        </Formik>

                    </article>
                </section>
            </main>
        </React.Fragment>
    )
}